export default __webpack_public_path__ + "static/media/filter.5b649fa8.svg";